const fileTypes = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  HTML: 'HTML',
  DOCUMENT: 'DOCUMENT',
  SHEETS: 'SHEETS',
  ANY: 'ANY',
  CSV: 'CSV'
};

export default fileTypes;